module.exports = __webpack_public_path__ + "img/icon_tel.83efcf8.svg";